
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/systems/[...slug]",
      function () {
        return require("private-next-pages/systems/[...slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/systems/[...slug]"])
      });
    }
  